<div class="container">
    <div class="header">
        <span class="sub-title">
            {{ 'editor.color-state.dialog.sub-title' | translate }}
        </span>
        <h4 class="main-title">
            {{ 'editor.color-state.dialog.main-title' | translate }}
        </h4>
    </div>
    <div class="content">
        <div class="description">
            {{ 'editor.color-state.dialog.description.part1' | translate }}
            <span class="font-style">
                {{ 'editor.color-state.dialog.description.part2' | translate }}
            </span>
            {{ 'editor.color-state.dialog.description.part3' | translate }}
            <span class="font-style">
                {{ 'editor.color-state.dialog.description.part4' | translate }}
            </span>
            {{ 'editor.color-state.dialog.description.part5' | translate }}
        </div>
        <div class="system-color-url" (click)="goSystemColorPage()">
            {{ 'editor.color-state.dialog.url' | translate }}
        </div>
        <div class="custom-color-container">
            <div class="title">
                {{ 'editor.color-state.dialog.custom-color-title' | translate }}
            </div>
            <div *ngFor="let colorData of customColorList" (click)="systemColorSelect(colorData.id)">
                <app-system-color-input
                    [data]="colorData"
                    [readonly]="true"
                    [selected]="selectedColorId === colorData.id">
                </app-system-color-input>
            </div>
        </div>
    </div>
</div>

<div class="buttons-container">
    <div class="cancel button" (click)="cancel()">
        {{ 'dlg.cancel' | translate }}
    </div>
    <div class="create button" [class.disabled]="isCreatingDisabled()" (click)="createRange()">
        {{ 'mimic.settings.range.new-dialog.button-text' | translate }}
    </div>
</div>
